import type { Store } from "pinia";

import { dismissAllTemporaryNotifications, getTemporaryNotificationCount, notify } from "~/components/notifications";
import { goBackOrHome, goHome } from "~/router/common";
import { ViewKind } from "~/shared/enums";

export const handleOneStepTowardHomeState = (store: Store) => {
  const appStore = store.$useAppStore();

  const router = store.$router;
  const route = router.currentRoute.value;

  if (route.name === "superuser_dashboard" || route.name === "superuser_dashboard_tab") {
    goHome();
    return true;
  }

  if (route.name === "console" || route.name === "latency") {
    goBackOrHome();
    return true;
  }

  if (getTemporaryNotificationCount() > 0) {
    dismissAllTemporaryNotifications();
    return true;
  }

  // TODO modals remove these modals which are often sub-modals and should be handled better with a better modal management system
  if (appStore.linkOpenInModal) {
    appStore.setLinkOpenInModal(null);
    return true;
  }

  if (appStore.mediaOpenInFullscreen) {
    appStore.setFullscreenMediaModalOpen(null);
    return true;
  }

  if (appStore.deleteModalConfig) {
    appStore.setDeleteConfirmationModalOpen(null);
    return true;
  }

  if (appStore.movePageModalConfig) {
    appStore.setMovePageConfirmationModalOpen(null);
    return true;
  }

  if (appStore.settingsModalOpen) {
    appStore.setSettingsModalOpen(false);
    return true;
  }
  // END TODO modals

  const visualization = appStore.getActiveVisualization();

  if (visualization.getSelectedRows().length > 0) {
    visualization.deselectAll();
    return true;
  }

  if (appStore.currentPage?.kind === ViewKind.SEARCH) {
    goBackOrHome();
    return true;
  }

  if (route.name === "agent") {
    router.push({ name: "agents" });
    return true;
  }

  return false;
};

const stepTowardHomeState = (event: KeyboardEvent, store: Store) => {
  const actionHappened = handleOneStepTowardHomeState(store);
  if (actionHappened) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
};

const registerGlobalEventListeners = (store: Store) => {
  const pageStore = store.$usePageStore();

  window.addEventListener("keydown", (event) => {
    switch (event.key) {
      case "Escape": {
        stepTowardHomeState(event, store);
        break;
      }
      case "s": {
        if ((pageStore.isMac ? event.metaKey : event.ctrlKey) && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          notify({
            id: "auto-save-notification",
            message: "Dart automatically saves all of your work, you don't have to do anything to save",
          });
        }
        break;
      }
      default: {
        break;
      }
    }
  });
};

export default registerGlobalEventListeners;
